import React from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  packageUrl: string;
  fileName?: string;
}

export const DownloadUnityPackageButton: React.FC<Props> = ({ packageUrl, fileName = "3DCrate.unitypackage" }) => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = packageUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

return (
  <div className="d-none d-md-flex justify-content-end my-2">
    <Button variant="primary" onClick={handleDownload} className="d-flex align-items-center">
      <img width="24" height="24" src="/unity_icon.webp" className="-2"/> {' '} Download Plugin
    </Button>
  </div>
);

};
